import { useEffect, useState } from "react";
import MorningMeetingContainer from "../MorningMeetingNotes/MorningMeetingNotes.styles";
import HomeList from "components/Screens/Home/HomeList/HomeList";
import MorningNotesRow from "components/Screens/Company/MorningNotesRow/MorningNotesRow";
import { useSettings } from "context/Settings.context";
import * as Database from "utils/database.utils";
import { GroupByEnum } from "../MorningMeetingNotes/MorningMeetingNotes";

type NoteByTopicClassifier = {
    days_since_last_note: number;
    last_note_added: string;
    note_count: number;
    topic_classifier_id: string;
    topic_classifier_value: string;
};

const OtherNotes = () => {
    const { setShowLoadingToast } = useSettings();
    const [notesByTopic, setNotesByTopic] = useState<NoteByTopicClassifier[]>(
        []
    );
    const [isLoading, setIsLoading] = useState(false);

    const getNotes = async () => {
        setShowLoadingToast({ show: true, message: "LOADING" });
        setIsLoading(true);

        const response = await Database.get(
            "api/bqmq_voting/get-morning-meeting-notes-by-topic-classifier"
        );

        if (response.ok) {
            const data = await response.json();
            setNotesByTopic(data.data as NoteByTopicClassifier[]);
        }

        setShowLoadingToast({ show: false, message: "LOADING" });
        setIsLoading(false);
    };

    useEffect(() => {
        getNotes();
    }, []);

    return (
        <MorningMeetingContainer style={{ paddingTop: "20px" }}>
            <HomeList
                data={notesByTopic}
                row={(row: any) => (
                    <MorningNotesRow
                        data={row}
                        groupBy={GroupByEnum.BY_TOPIC_CLASSIFIER}
                    />
                )}
                title={"MORNING MEETING NOTES"}
                countColor={""}
                loading={isLoading}
            />
        </MorningMeetingContainer>
    );
};

export default OtherNotes;
